<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      class="table-css"
      :columns="columns"
      :data="tableIdentityAndAccessManagementResourceListData"
      style="width: 100.1%;"
      :max-height="tableHeight"
    ></Table>
  </div>
</template>
<script>
var tableIdentityAndAccessManagementResourceVue = {};
export default {
  name: "TableIdentityAndAccessManagementResource",
  data() {
    return {
      tableHeight: 0,
      iamUserName: "",
      columns: [
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.accountName"),
          minWidth: 150,
          fixed: "left",
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.accountID"),
          minWidth: 150,
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.userName"),
          minWidth: 150,
          key: "userName"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.group"),
          minWidth: 150,
          key: "groupNames"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.accessKeyAge"),
          minWidth: 150,
          key: "accessKeyAge"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.passwordAge"),
          minWidth: 150,
          key: "passwordAge"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.lastActivity"),
          minWidth: 150,
          key: "lastActivity"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.mfa"),
          minWidth: 150,
          key: "mfaDesc"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.policyName"),
          minWidth: 150,
          key: "policyName"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.policyTypeName"),
          minWidth: 150,
          key: "policyTypeName"
        },
        {
          title: this.$t("RAM.AWS.IdentityAndAccessManagement.policyFrom"),
          minWidth: 150,
          fixed: "right",
          key: "policyFrom"
        }
      ],
      tableIdentityAndAccessManagementResourceListData: []
    };
  },
  beforeCreate: function() {
    tableIdentityAndAccessManagementResourceVue = this;
  },
  mounted: function() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
    tableIdentityAndAccessManagementResourceVue.pagingQueryIamData();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 194;
    },
    showAll: function() {
      tableIdentityAndAccessManagementResourceVue.pagingQueryIamData();
    },
    // 分页显示数据
    /****************************************************/
    pagingQueryIamData: function() {
      eventBus.$on("companyId", function(val) {
        tableIdentityAndAccessManagementResourceVue.companyId = val;
      });
      eventBus.$on("accountIds", function(val) {
        tableIdentityAndAccessManagementResourceVue.accountIds = val;
      });
      eventBus.$on("iamUserName", function(val) {
        tableIdentityAndAccessManagementResourceVue.iamUserName = val;
      });
      eventBus.$on("mfa", function(val) {
        tableIdentityAndAccessManagementResourceVue.mfa = val;
      });
      this.$api.resourceManagement
        .selectAWSIamByPage({
          companyId: this.companyId,
          accountIds: this.accountIds,
          iamUserName: this.iamUserName,
          mfa: this.mfa
        })
        .then(res => {
          this.tableIdentityAndAccessManagementResourceListData =
            res.data.records;
        });
    }
  }
};
</script>
<style scoped>
/* 滚动条 */
/* .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #ccc;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
  background: #eeeeef;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
  background-color: #eeeeef;
}
.table-css >>> .ivu-table-overflowX {
  overflow-x: hidden !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/iam/TableIdentityAndAccessManagementResource.vue